// @flow
import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import enhanceWithClickOutside from "react-click-outside";
import { connect } from "react-redux";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { Icon, LocaleLink } from "../";
import styles from "./Notifications.scss";

class Notification extends Component {
    state = {
        showList: false
    };

    toggleList = () => {
        this.setState(prevState => ({
            showList: !prevState.showList
        }));
    };

    handleClickOutside = () => {
        this.setState({ showList: false });
    };

    notificationClick = (id_notification, link) => {
        const obj = {
            id_notification,
            is_read: true
        };
        this.props.readNotification(obj);
        this.handleClickOutside();
        window.open(link);
    };

    render() {
        const { data } = this.props;
        const count = data && !_.isEmpty(data) && data.length;
        const dataList =
            data && !_.isEmpty(data) ? (
                data.map((notification, index) => {
                    const duration = notification.created_at
                        ? moment.duration(
                              moment().diff(notification.created_at)
                          )
                        : "";
                    let val = moment(notification.created_at).format(
                        "MMM DD h:mm:ss a"
                    );
                    const hours = duration && duration.asHours();
                    if (Number(hours) < 24) {
                        val = I18n.getText("notification.hrs-ago", {
                            hours: Math.round(Number(hours))
                        });
                    }
                    if (Number(hours) < 1) {
                        const minutes = duration && duration.asMinutes();
                        val = I18n.getText("notification.minutes-ago", {
                            minutes: Math.round(Number(minutes))
                        });
                    }
                    return (
                        <div
                            className={styles.notBox}
                            onClick={() =>
                                this.notificationClick(
                                    notification.id_notification,
                                    notification.directs_to_link
                                )
                            }
                        >
                            <p className={styles.notText}>
                                {notification[`message_${Helper.getLang()}`]}
                            </p>
                            <div className={styles.notTime}>{val}</div>
                        </div>
                    );
                })
            ) : (
                <div className={styles.blank}>
                    <p>{I18n.getText("notification.blank")}</p>
                </div>
            );
        return (
            <div className={styles.notificationIcon}>
                <div className={styles.icon} onClick={this.toggleList}>
                    <Icon name="bell" />
                    {count && <div className={styles.count}>{count}</div>}
                </div>
                {this.state.showList && (
                    <div className={styles.list}>
                        <div className={styles.listCtr}>
                            <div className={styles.notHead}>
                                <span>
                                    {I18n.getText("header.notifications")}
                                </span>
                                <span className={styles.viewAll}>
                                    <LocaleLink to={"/notifications"}>
                                        {I18n.getText(
                                            "header.notifications-view-all"
                                        )}
                                    </LocaleLink>
                                </span>
                            </div>
                            <div className={styles.listWrapper}>{dataList}</div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default enhanceWithClickOutside(Notification);



// WEBPACK FOOTER //
// ./src/components/common/notifications/Notifications.js